import React from 'react';

/**
 * HasPermission component that renders children only if the user has the required permission.
 * 
 * @param {Object} props
 * @param {string|string[]} props.slug - Permission slug(s) required to render children
 * @param {React.ReactNode} props.children - Component to render if user has permission
 * @param {boolean} props.checkAll - If true, requires all permissions in slug array. If false, requires at least one (default: true).
 */
const HasPermission = ({ slug, children, checkAll = true }) => {
    // Get user data from localStorage
    const loginData = JSON.parse(localStorage.getItem('User'));

    if (!loginData || !loginData.permissions) {
        return null;
    }

    const requiredSlugs = Array.isArray(slug) ? slug : [slug];
    const userPermissions = loginData.permissions;

    let hasAccess = false;
    if (checkAll) {
        hasAccess = requiredSlugs.every(s => userPermissions.includes(s));
    } else {
        hasAccess = requiredSlugs.some(s => userPermissions.includes(s));
    }

    return hasAccess ? children : null;
};

export default HasPermission;
